export const SHOW_SEARCH = 'SHOW_SEARCH'
export const HIDE_SEARCH = 'HIDE_SEARCH'

export const SET_CONTACTS_SEARCH = 'SET_CONTACTS_SEARCH'
export const SET_MESSAGES_SEARCH = 'SET_MESSAGES_SEARCH'
export const SET_CHAT_SEARCH = 'SET_CHAT_SEARCH'
export const SET_NOTES_SEARCH = 'SET_NOTES_SEARCH'
export const SET_EVENTS_SEARCH = 'SET_EVENTS_SEARCH'
export const SET_CASES_SEARCH = 'SET_CASES_SEARCH'